/** Normalizes Russian-style input to E.164 (+7XXXXXXXXXX); other +codes pass through. */
export function normalizePhone(input: string): string | null {
  const digits = input.replace(/[^\d+]/g, '');
  if (/^\+[1-9]\d{7,14}$/.test(digits)) return digits;
  const d = digits.replace(/\D/g, '');
  if (d.length === 11 && (d.startsWith('8') || d.startsWith('7'))) return `+7${d.slice(1)}`;
  if (d.length === 10 && d.startsWith('9')) return `+7${d}`;
  return null;
}

export function formatPhone(e164: string): string {
  const m = /^\+7(\d{3})(\d{3})(\d{2})(\d{2})$/.exec(e164);
  return m ? `+7 ${m[1]} ${m[2]}-${m[3]}-${m[4]}` : e164;
}

/** As-you-type mask for Russian numbers ("+7 999 123-45-67"); any other +code is left as typed. */
export function formatPhoneInput(input: string): string {
  const raw = input.trim();
  if (raw.startsWith('+') && !raw.startsWith('+7')) return raw.replace(/[^\d+\s()-]/g, '');
  let d = raw.replace(/\D/g, '');
  if (!d) return raw.startsWith('+') ? '+' : '';
  if (d[0] === '8' || d[0] === '7') d = d.slice(1);
  d = d.slice(0, 10);
  let out = '+7';
  if (d.length > 0) out += ` ${d.slice(0, 3)}`;
  if (d.length > 3) out += ` ${d.slice(3, 6)}`;
  if (d.length > 6) out += `-${d.slice(6, 8)}`;
  if (d.length > 8) out += `-${d.slice(8, 10)}`;
  return out;
}
